import React, { Component } from 'react';
import './Pricing.css';

class Pricing extends Component {
    render() {
        return (
            <div className="Pricing-container">
                <div className="Pricing-content-top"></div>
                <div className="Pricing-content-mid">
                    <div className="Pricing-text">
                        Our rooms/chapters can be played in any order.
                    </div>
                    {/* <div className="Pricing-content-header">PRICING</div>
          <div className="Pricing-info">
            Single Chapter - $35 (Mon-Thurs) <span className="Pricing-dot"></span> $37 (Fri-Sun)
          </div> */}
                    {/* <div className="Pricing-content-header">MINI COMBO GAME - $45</div>
          <div className="Pricing-text">
            Special combined Chapter 1 Chapter 2 and Chapter 3 with an interactive story. <br />
            Experience an intense <b>60 min</b> journey of an immersive live adventure game set in a
            post-apocalyptic world. <br />
            This special mini version interactive experience includes: <br />
            <br />
            Multiple escape rooms - <b>(Chapter 1, 2 & 3 combined)</b>
          </div> */}

                    <div className="Pricing-content-header">ALL GAMES ARE PRIVATE<br/></div>
                    <div className="Pricing-text">
                        SINGLE GAME ROOM PRICING<br />
                        <table>
                            <tbody>
                                <tr>
                                    <td>People</td>
                                    <td>Ticket Prices</td>
                                    <td>Total</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>$55/person</td>
                                    <td>$110</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>$50/person</td>
                                    <td>$150</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>$47/person</td>
                                    <td>$188</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>$45/person</td>
                                    <td>$225</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>$43/person</td>
                                    <td>$258</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>$41/person</td>
                                    <td>$287</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>$40/person</td>
                                    <td>$320</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="Pricing-content-bottom"></div>
            </div>
        );
    }
}

export default Pricing;
